import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';
import { format } from 'date-fns';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  api: string;
  DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

  constructor(protected http: HttpClient) {
    this.api = environment.customerApiUrl;
  }

  getRate(from: string, to: string): Observable<any> {
    const url = `${this.api}/trade/get-realtime-rate/${from}${to}`;
    return this.http.get<any>(url);
  }

  checkCurrencyIsAvailableOnPortal(param): Observable<any> {
    return this.http.post(`${this.api}/currency/check-currency-is-available-on-portal`, param);
  }

  currencyPairIsAvailableOnPortal(param): Observable<any> {
    return this.http.post(`${this.api}/currency/check-currency-pair-is-available-on-portal`, param);
  }
}
